import React from 'react';
import { Tooltip, Box } from '@mui/material';
import { keyframes } from '@mui/system';

// Pulse animation for connecting state
const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

const WebSocketStatus = ({ loading, error, isConnected }) => {
  // Determine status - subscriptions stay "loading" while listening, so check isConnected
  const getStatus = () => {
    if (error) return { color: '#FF4444', text: 'Disconnected', pulse: false };
    if (isConnected) return { color: '#4CAF50', text: 'Connected & Listening', pulse: false };
    if (loading) return { color: '#FFA500', text: 'Connecting...', pulse: true };
    return { color: '#999999', text: 'Not Started', pulse: false };
  };

  const status = getStatus();

  return (
    <Tooltip title={`Real-time notifications: ${status.text}`} arrow>
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: status.color,
          animation: status.pulse ? `${pulse} 1.5s ease-in-out infinite` : 'none',
          boxShadow: `0 0 4px ${status.color}`,
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'scale(1.3)',
          }
        }}
      />
    </Tooltip>
  );
};

export default WebSocketStatus;

